import { useEffect, useState } from 'react';
import {
  fetchProductDashboardSummary,
  isLocalBridgeApiEnabled,
  type ProductDashboardSummary,
} from '../../services/bridgeSessionDataAdapter';
import { getProductDomainSession } from '../../services/productDomainSessionApi';

type NavArgs = {
  productId: string | undefined;
  currentLocationProductName: string | undefined;
  currentLocationProductId: string | undefined;
  navigateTo: (args: {
    level: 'product';
    productId: string;
    productName: string;
  }) => void;
};

export function useProductDashboardData({
  productId,
  currentLocationProductName,
  currentLocationProductId,
  navigateTo,
}: NavArgs) {
  const [summary, setSummary] = useState<ProductDashboardSummary | null>(null);
  const [summaryLoading, setSummaryLoading] = useState(true);

  useEffect(() => {
    if (!productId) {
      setSummary(null);
      setSummaryLoading(false);
      return;
    }
    setSummaryLoading(true);
    if (isLocalBridgeApiEnabled()) {
      getProductDomainSession(productId).then((session) => {
        if (
          session?.product_name &&
          (!currentLocationProductName || currentLocationProductId !== productId)
        ) {
          navigateTo({
            level: 'product',
            productId,
            productName: session.product_name,
          });
        }
      });
    } else if (!currentLocationProductName && productId) {
      navigateTo({
        level: 'product',
        productId,
        productName: `Product ${productId.substring(0, 8)}`,
      });
    }
    fetchProductDashboardSummary(productId).then((s) => {
      setSummary(s ?? null);
      setSummaryLoading(false);
    });
  }, [productId, currentLocationProductName, currentLocationProductId, navigateTo]);

  return { summary, summaryLoading };
}
